export function validateCuit(cuit: string): boolean {
  let acumulado = 0;
  let digitosCollection = cuit.split('');
  let digito = digitosCollection.pop();
  let cuitLength = digitosCollection.length;

  for (let index = 0; index < cuitLength; index++) {
    let digitoActual: number = +digitosCollection[9 - index];
    acumulado += digitoActual * (2 + (index % 6));
  }

  let verificador = 11 - (acumulado % 11);
  if (verificador == 11) {
    verificador = 0;
  } else if (verificador == 10) {
    verificador = 9;
  }

  return +digito == verificador;
}

export function finalDotVerificator(value: string): string {
  value = value.trim();
  if (value.slice(value.length - 1) != '.') {
    value = `${value}.`;
  }
  return value;
}
